import { useCallback, useEffect, useState } from 'react';
import VideoList from './components/video_list/video_list';
import styles from './app.module.css';
import SearchHeader from './components/search_header/search_header';
import VideoDetail from './components/video_detail/video_detail';

function App({youtube}) {
  const [videos,setVideos] = useState([]); 
  const [selectedVideo,setSelectedVideo] = useState(null);

  const selectVideo = video =>{
    setSelectedVideo(video);
  };

  const search = useCallback(
    query => {
      setSelectedVideo(null);
      youtube.search(query).then(videos => 
        setVideos(videos));
      },
      [youtube]
    );


  useEffect(()=>{     //마운트가 되었거나 업데이트가 될 때 콜백함수 등록
    youtube.mostPopular().then(videos => setVideos(videos));
  },[youtube]);
  
  return(
    <div className={styles.app}>
      <SearchHeader onSearch ={search} />
      
      <section className ={styles.content}>
        {selectedVideo && (<div className= {styles.detail}>
          <VideoDetail video = {selectedVideo} />
        </div> )} 

        <div className={styles.list}>
          <VideoList videos = {videos} onVideoClick = {selectVideo} display = {selectedVideo ? 'list' : 'grid'} />
        </div>
      </section>
      
    </div>
  );
}

export default App;
